/* eslint-disable camelcase */
// NOSONAR
import { getEventHeader, safeTrim } from 'saddlebag-grappler';

import {
  getAdditionalServiceInfo,
  getURLTrackingParams,
} from './grappler-helpers';

const buildViewData = (options, utid, authState) => {
  const {
    analyticsPageName,
    analyticsPageUrl,
    culture,
    currentUrl,
    device,
    existingParams,
    featureTests,
    guid,
    isInternalUser,
    page_type,
    pageInstance,
    requestId,
    virtualReferrer,
    webNode,
  } = options;

  const grapplerViewData = {
    event_header: getEventHeader({
      authState,
      culture,
      device,
      featureTests,
      guid,
      virtualReferrer,
      utid,
    }),
    additional_service_info: getAdditionalServiceInfo(webNode),
    analytics_page_name: safeTrim(analyticsPageName),
    analytics_page_url: safeTrim(analyticsPageUrl),
    is_internal_user: isInternalUser,
    page_type: safeTrim(page_type),
    ...(pageInstance && { page_instance: pageInstance }),
    request_id: safeTrim(requestId),
    url: safeTrim(currentUrl),
    url_tracking_params: getURLTrackingParams(existingParams),
  };

  return grapplerViewData;
};

export { buildViewData };
